export default __webpack_public_path__ + "static/media/bcorp-logo.b24c60d9.svg";